// src/components/common/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loading from './Loading';

/**
 * Protected Route Component
 * 
 * Wraps routes that require authentication
 * Redirects to login if user is not authenticated
 * 
 * Usage:
 * <Route 
 *   path="/cart" 
 *   element={
 *     <ProtectedRoute>
 *       <CartPage />
 *     </ProtectedRoute>
 *   } 
 * />
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // Show loading spinner while checking authentication
  if (loading) {
    return <Loading fullScreen message="Checking authentication..." />;
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Render protected content if authenticated
  return children;
};

export default ProtectedRoute;